import { Link } from "react-router-dom";
import { LineReveal, Reveal } from "@/lib/motion";
import { ChevronRight } from "lucide-react";

export const PageHero = ({ overline, titleLines, subtitle }) => {
  return (
    <section className="relative pt-36 pb-16 md:pt-44 md:pb-24 overflow-hidden">
      <div className="absolute inset-0 radial-red" aria-hidden="true" />
      <div className="absolute inset-0 opacity-[0.5]" aria-hidden="true"
        style={{ backgroundImage: "linear-gradient(hsl(240 6% 92%) 1px,transparent 1px),linear-gradient(90deg,hsl(240 6% 92%) 1px,transparent 1px)", backgroundSize: "56px 56px", maskImage: "radial-gradient(70% 60% at 30% 40%, #000 40%, transparent 100%)" }} />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <nav className="flex items-center gap-2 text-xs text-muted-foreground mb-6">
            <Link to="/" className="hover:text-foreground transition-colors">Home</Link>
            <ChevronRight className="w-3.5 h-3.5" />
            <span className="text-foreground">{overline}</span>
          </nav>
        </Reveal>
        <h1 className="text-5xl md:text-7xl font-heading font-extrabold tracking-tighter leading-[0.95]">
          <LineReveal lines={titleLines} />
        </h1>
        {subtitle && (
          <Reveal delay={0.2} className="mt-6 max-w-2xl text-base md:text-lg text-muted-foreground leading-relaxed">
            {subtitle}
          </Reveal>
        )}
      </div>
    </section>
  );
};
